//http.ts
import axios, { AxiosRequestConfig } from 'axios'
import { objKeySort, deleteNullKey } from '../common/index'
import { showFailToast } from 'vant'
import qs from 'qs'
import md5 from 'js-md5'
import { lang } from '@/utils'
const excludeList = ['/architecture/upload']
const signKey = import.meta.env.VITE_APP_API_SIGN
// 设置请求头和请求路径
// @ts-ignore
axios.defaults.baseURL = import.meta.env.VITE_APP_API_BASE_URL
axios.defaults.timeout = 10000
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
axios.interceptors.request.use(
  (config?: any): AxiosRequestConfig<any> => {
    const token = window.sessionStorage.getItem('token')
    if (token) {
      //@ts-ignore
      config.headers.token = token
    }
    // 添加language参数
    const language = localStorage.getItem('language') || 'cn'
    config.headers.language = language === 'cn' ? 'CN' : 'EN'
    let data: any = ''
    /* 验签兼容get请求 */
    if (config.method === 'get' && config.url.indexOf('?') > 0) {
      data = qs.parse(config.url.split('?')[1])
      config.params = data || {}
    }
    if (excludeList.indexOf(config.url) == -1) {
      const _time = new Date().getTime()
      config.headers.ts = _time
      // const params = config.data;
      const params = deleteNullKey(config.data)
      const param = objKeySort(JSON.parse(params))
      const reg = new RegExp('"', 'g')
      const key =
        `${JSON.stringify(param)}&ts=${_time}&signKey=${signKey}`.replace(
          reg,
          ''
        )
      const md5UpperCase = md5(key).toUpperCase()
      config.headers.tmpSign = md5UpperCase
    }
    return config
  },
  (error) => {
    return error
  }
)
// 响应拦截
axios.interceptors.response.use((res) => {
  if (res.data.code != 1) {
    showFailToast(lang(res.data.msg))
  }
  return res
})

interface ResType<T> {
  code: number
  data?: T
  msg: string
  err?: string
}
interface Request {
  get<T>(url: string, params?: unknown): Promise<ResType<T>>
  post<T>(url: string, params?: unknown): Promise<ResType<T>>
  upload<T>(url: string, params: unknown): Promise<ResType<T>>
  download(url: string): void
}

const request: Request = {
  get(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, { params })
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err.data)
        })
    })
  },
  post(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, JSON.stringify(params))
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err.data)
        })
    })
  },
  upload(url, file) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, file, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err.data)
        })
    })
  },
  download(url) {
    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.src = url
    iframe.onload = function () {
      document.body.removeChild(iframe)
    }
    document.body.appendChild(iframe)
  }
}
export default request
